var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFund(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 258,
    viewBox: "0 0 259 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3496 61.1675H193.823V218.49H57.9537C42.156 218.49 29.3496 205.684 29.3496 189.886V61.1675Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5547 82.6201H229.575V218.49H158.065C118.571 218.49 86.5547 186.473 86.5547 146.979V82.6201Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3496 61.1675C29.3496 49.3193 38.9545 39.7144 50.8027 39.7144H193.823V82.6206H50.8027C38.9545 82.6206 29.3496 73.0156 29.3496 61.1675Z",
    fill: "#D4D5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.066 125.527H229.577V175.584H158.066V125.527Z",
    fill: "#D4D5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.824 161.281C199.748 161.281 204.551 156.479 204.551 150.555C204.551 144.631 199.748 139.828 193.824 139.828C187.9 139.828 183.098 144.631 183.098 150.555C183.098 156.479 187.9 161.281 193.824 161.281Z",
    fill: "#D4D5F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.1934e6d491e27e861ef1bff307e0f86e.svg";
export { ForwardRef as ReactComponent };